import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
export const VerticalBarIcon = ({ color, ...props }) => {
    const theme = useTheme();
    return (_jsx("svg", { width: "40", height: "52", viewBox: "0 0 40 52", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("line", { x1: "19", y1: "15", x2: "19", y2: "39", stroke: color ?? theme.colors.white, strokeWidth: "2", strokeLinejoin: "round" }) }));
};
//# sourceMappingURL=vertical_bar_icon.js.map